import React from "react";
import styled from "styled-components";
import { useState } from "react";
import Youtube from "./Newsy/Youtube";
import Web from "./Newsy/Web";
import Grafika from "./Newsy/Grafika";

const Projekty = styled.div`
  height: 80vh;
  width: 100%;
  display: flex;
  background-color: #2e1919;
  z-index: 1;
  @media only screen and (max-width: 800px) {
    flex-direction: column;
  }
`;

const Menu = styled.div`
  width: 25%;
  margin-right: 5%;
  height: 100%;
  justify-content: space-evenly;
  display: flex;
  flex-direction: column;
  padding-bottom: 5vh;
  & > h1 {
    font-size: 2rem;
    text-align: center;
    color: #f8ffe8;
  }
  @media only screen and (max-width: 800px) {
    height: 30%;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
const MenuZwei = styled.div`
  width: 100%;
  height: auto;
  justify-content: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  @media only screen and (max-width: 800px) {
    height: 30%;
    width: 100%;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
`;

const Main = styled.div`
  width: 70%;
  justify-content: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  & > h1 {
    color: #f8ffe8;
    font-size: 3rem;
    padding: 0;
    margin: 0;
  }
  @media only screen and (max-width: 800px) {
    height: 70%;
    width: 100%;
    & > h1 {
      font-size: 2rem;
    }
  }
`;

const Button = styled.div`
  color: #f8ffe8;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20vw;
  margin: 1.5vh;
  height: 10vh;
  background-color: #798460;
  border-radius: 1.5vh;
  cursor: pointer;
  transition: 0.3s;
  font-size: 1.3rem;
  user-select: none;

  &:hover {
    transform: scale(0.85);
  }
  &:first-child {
    background-color: #5b2632;
  }

  @media only screen and (max-width: 800px) {
    width: 30vw;
  }
`;
const ProjektContent = styled.div`
  margin-top: 4vh;
  color: #2e1919;

  height: 70%;
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border-radius: 2vh;
  & > * {
    border: 0.3rem solid #798460;
    border-radius: 0.5rem;
  }
  & > iframe {
    width: 90%;
    height: 90%;
    margin: 1vw;
  }
  & > img {
    margin: 1vw;
    width: 90%;
    height: 90%;
  }
  @media screen and (max-width: 479px) {
    justify-content: center;
    height: 50%;
    & > p {
      display: none;
    }
    & > iframe {
      width: 95%;
      height: 95%;
      margin: 0;
    }
    & > img {
      width: 95%;
      height: 95%;
      margin: 0;
    }
  }
`;

function News() {
  const [kontent, wybierajKontent] = useState(<Youtube />);

  const show = kontent;

  function showDown(x) {
    document.getElementById("chuj1").style.backgroundColor = "#798460";
    document.getElementById("chuj2").style.backgroundColor = "#798460";
    document.getElementById("chuj3").style.backgroundColor = "#798460";
    document.getElementById("chuj" + x).style.backgroundColor = "#5B2632";
  }
  return (
    <Projekty>
      <Main>
        <h1>Mój najnowszy projekt</h1>
        {show}
      </Main>
      <Menu>
        <h1>Wybierz kategorię</h1>
        <MenuZwei>
          <Button
            id="chuj1"
            onClick={() => {
              wybierajKontent(<Youtube />);
              showDown(1);
            }}
          >
            Filmy
          </Button>
          <Button
            id="chuj2"
            onClick={() => {
              wybierajKontent(<Web />);
              showDown(2);
            }}
          >
            Webdesign
          </Button>

          <Button
            id="chuj3"
            onClick={() => {
              wybierajKontent(<Grafika />);
              showDown(3);
            }}
          >
            Grafika
          </Button>
        </MenuZwei>
      </Menu>
    </Projekty>
  );
}

export default News;
export { ProjektContent };
